import { checkAIMeta, checkIsProcessed } from "@/utils/misc";
import { ImageNode, IStatelessPlugin, pluginFactory, CallOrders, IBoard } from "@noli/core";
import { debounce } from "lodash";
function getId(node: ImageNode, type?: string) {
  return `watermark_${type ?? node.renderParams.renderType ?? "fit"}_${node.alias}`;
}
export const WATERMARK_NODES_PLUGIN_NAME = "watermark_nodes";
export class WatermarkNodePlugin extends IStatelessPlugin {
  waterMarkSet: Set<string> = new Set();
  renderTypeRecord: { [k: string]: string } = {};
  debounceCheck: () => void;
  constructor(board: IBoard) {
    super(board);
    const style = document.createElement("div");
    style.innerHTML = '[class^="watermark"] { border: 1px solid red; }';
    document.head.appendChild(style);
    this.debounceCheck = debounce(this.check.bind(this), 500);
  }

  get selector() {
    return this.board.selectorPlugin;
  }

  get nodesLayer() {
    return document.getElementById("nodesLayer");
  }

  getDom(id: string, isThirdParty: boolean) {
    const node = document.createElement("div");
    node.id = id;
    node.style.width = "100%";
    node.style.height = "100%";
    node.style.position = "absolute";
    node.style.zIndex = "1";
    node.style.left = "0";
    node.style.top = "0";
    node.innerHTML = `<div style='color: red; position: absolute; right: 4%; bottom: 4%; width: 25%;'><img src='http://nolipix-js.nolibox.com/assets/creator/${
      isThirdParty ? "aigc" : "node"
    }_watermark.png' style="width: 100%" /></div>`;
    return node;
  }

  createWatermarkFor(alias: string, isThirdParty = false) {
    const node = this.graph.getExistingNode(alias) as ImageNode;
    const dom = this.getDom(getId(node), isThirdParty);
    const renderType = node.renderParams.renderType ?? "fit";
    if (renderType === "fit") {
      const timer = setInterval(() => {
        if (document.getElementById(`${node.alias}`)?.childNodes[0]) {
          document.getElementById(`${node.alias}`)?.childNodes[0]?.appendChild(dom);
          clearInterval(timer);
        }
      }, 300);
    } else {
      document.getElementById(`${node.alias}`)?.appendChild(dom);
    }
  }

  deleteWatermarkFor(alias: string) {
    const node = this.graph.getExistingNode(alias) as ImageNode;
    const dom = document.getElementById(getId(node, this.renderTypeRecord[alias]));
    if (dom) {
      dom.remove();
    }
  }

  check() {
    const set = new Set<string>();
    this.graph.allSingleNodes.forEach((node) => {
      if (
        node.alias.includes("loading") ||
        node.alias.includes("wenxin") ||
        node.alias.includes("upload")
      )
        return;
      const isThirdParty =
        /(monkey|draft)/.test(node.alias) ||
        /(monkey|draft)/.test(node.params.meta?.data?.from?.type);
      if (node.alias.includes("duplicate") && !checkIsProcessed(node.meta) && !isThirdParty) return;
      if (node.type === "image") {
        const renderType = node.renderParams.renderType ?? "fit";
        set.add(node.alias);
        if (!this.waterMarkSet.has(node.alias)) {
          this.createWatermarkFor(node.alias, isThirdParty);
          this.renderTypeRecord[node.alias] = renderType;
        } else if (
          this.waterMarkSet.has(node.alias) &&
          renderType !== this.renderTypeRecord[node.alias]
        ) {
          this.deleteWatermarkFor(node.alias);
          this.createWatermarkFor(node.alias, isThirdParty);
          this.renderTypeRecord[node.alias] = renderType;
        }
      }
    });
    this.waterMarkSet = set;
    Object.keys(this.renderTypeRecord).forEach((alias) => {
      if (!this.waterMarkSet.has(alias)) {
        delete this.renderTypeRecord[alias];
      }
    });
  }

  async afterRefresh(): Promise<void> {
    this.debounceCheck();
  }
}

pluginFactory.register(WATERMARK_NODES_PLUGIN_NAME, { callOrders: CallOrders.zeros() })(
  WatermarkNodePlugin,
);
